import { createAsyncThunk } from '@reduxjs/toolkit';
import { Interaction } from '@constants';
import { WarmupDataKey } from '@services/WarmupData';
import { canAddNewPaymentMethod } from '@utils/app';
import type { ThunkApiConfig } from '../store.types';

export const getIsRecurringSupported = createAsyncThunk<
  boolean,
  string,
  ThunkApiConfig
>('paymentMethods/fetch', async (accountId, { extra }) => {
  const { flowAPI, warmupData, paymentMethodsApi } = extra;
  const { environment, errorHandler, errorMonitor, fedops, panoramaClient } =
    flowAPI;

  try {
    fedops.interactionStarted(Interaction.LoadRecurringPaymentMethods);
    panoramaClient.transaction(Interaction.LoadRecurringPaymentMethods).start();

    if (environment.isViewer) {
      const methods = await paymentMethodsApi.getRecurringPaymentMethods(
        accountId,
      );
      fedops.interactionEnded(Interaction.LoadRecurringPaymentMethods);
      panoramaClient
        .transaction(Interaction.LoadRecurringPaymentMethods)
        .finish();

      const canAddNewMethod = canAddNewPaymentMethod(methods || []);
      warmupData.set(WarmupDataKey.CanAddNewPaymentMethod, canAddNewMethod);

      return canAddNewMethod;
    }

    fedops.interactionEnded(Interaction.LoadRecurringPaymentMethods);
    panoramaClient
      .transaction(Interaction.LoadRecurringPaymentMethods)
      .finish();
    return true;
  } catch (error) {
    const resolvedError = errorHandler.getResolvedError(error);

    console.error('[my-wallet]:', resolvedError);

    if (error instanceof Error) {
      errorMonitor.captureException(error);
      panoramaClient.errorMonitor().reportError(error);
    }

    return false;
  }
});
